// Màn "Kết quả" chỉ HIỂN THỊ tóm tắt hoàn thành do backend tính
// (GET /elearning/my/completion-summary) — không tự tính giờ trong trình
// duyệt. Trước 19/10/2026 LMS tự tính và khi dữ liệu sách chưa tải xong thì
// rơi về công thức cũ → hiện "Đã hoàn thành" sai.

export const STATUS_VIEW = {
  completed: { label: 'Đã hoàn thành', tone: 'success' },
  // Đủ giờ nhưng chưa xong các phần — trạng thái trung gian sửa được.
  missing_parts: { label: 'Chưa học đủ các phần', tone: 'warning' },
  not_enough_time: { label: 'Chưa đủ giờ', tone: 'danger' },
};

// Dòng bảng "Kết quả tổng hợp": theo thứ tự danh sách môn của LMS, chỉ môn
// backend trả về (môn được gán). Chưa có dữ liệu → [] (không đoán số).
export function buildSummaryRows(completionSummary, elearningCourses, elearningUser) {
  const perCourse = completionSummary?.perCourse;
  if (!perCourse) return [];
  const keys = Object.keys(elearningCourses || {}).filter((k) => perCourse[k]);
  // Môn backend có mà danh sách LMS chưa có → vẫn hiện, cuối bảng.
  Object.keys(perCourse).forEach((k) => { if (!keys.includes(k)) keys.push(k); });
  return keys
    .filter((k) => elearningUser?.elearningLessons?.includes?.(Number(k)) !== false)
    .map((k) => {
      const c = perCourse[k];
      return {
        key: k,
        name: elearningCourses?.[k]?.fullname || c.courseName,
        requiredSeconds: c.requiredSeconds || 0,
        countedSeconds: c.countedSeconds || 0,
        status: c.status,
      };
    });
}

// { [cmid]: giây } của một môn — cột "Thời gian tích luỹ" từng hoạt động.
export function activityTimeByCmid(completionSummary, courseKey) {
  const list = completionSummary?.perCourse?.[courseKey]?.activities || [];
  return Object.fromEntries(list.map((a) => [a.cmid, a.timeSpent]));
}

// Trạng thái sau một lượt tải. "Tải lại" lỗi khi đã có số → giữ số cũ và chỉ
// báo (notify); chỉ khi chưa có số nào mới hiện lỗi thay bảng.
export function applySummaryResult(state, result) {
  if (result?.ok) return { summary: result.data, error: null, notify: null };
  if (state?.summary) return { summary: state.summary, error: null, notify: result?.error || true };
  return { summary: null, error: result?.error || new Error('load failed'), notify: null };
}

// Backend không tải được một số bài kiểm tra từ Moodle → số giờ có thể thiếu.
export function dataWarningText(completionSummary) {
  if (!completionSummary?.dataWarnings?.length) return null;
  return 'Một số bài kiểm tra chưa tải được từ hệ thống học — số giờ có thể đang thiếu. Bấm "Tải lại" sau ít phút.';
}
